import {Dialog, DialogContent} from '@features/ui/components/dialog';
import {McpContent} from './McpView';

type McpModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

export function McpModal({isOpen, onClose}: McpModalProps) {
  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className='max-w-lg' hideCloseButton>
        <div className='max-h-[85vh] overflow-y-auto scrollbar-hide'>
          <McpContent />
        </div>
      </DialogContent>
    </Dialog>
  );
}
